import Alpine from "alpinejs";
import { updateMobilePdpView, updateUrlParams } from "./pdp-utils";
import { variantSizeSelection } from "./pdp-variants";
import { updateMediaGrid } from "./pdp-media";
import { fusionAtcAdd } from "./pdp-atc";
import { updateWishlistAndDispatchEvent } from "./wishlistHelper";

export const pdpCore = () => {
	// Args e = click event data from clicked on product
	document.addEventListener("newSelectedProduct", (e) => {
		// Do nothing if its already selected
		if (
			e.target.id == Alpine.store("activeProduct").activeProduct.id ||
			!e.target.id ||
			typeof e.target.id == undefined ||
			typeof e.target.id == "undefined"
		)
			return;

		// IMPORTANT check for product swapping and call sentry critical errors if issues
		const newProductObject = window.fusionDataProvider.find(
			(o) => o.product.id === parseInt(e.target.id)
		);
		if (
			!newProductObject ||
			typeof newProductObject == "undefined" ||
			typeof newProductObject === undefined
		)
			return;

		// __+|+__ ALPINE UPDATE __+|+__
		Alpine.store("activeProduct").updateActiveProduct(newProductObject.product);

		// Handle single variant products only
		if (newProductObject.product.variants.length === 1) {
			Alpine.store("selectedVariant").updateActiveVariant(
				newProductObject.product.variants[0]
			);
		}

		// On a valid product change we need to create a new set of seed data for the wishlist button and update attributes on the element
		const firstAvailableVariant = newProductObject.product.variants.find(variant => variant.available);
		if (firstAvailableVariant) {
			updateWishlistAndDispatchEvent(newProductObject.product.id, firstAvailableVariant.id, newProductObject.product.handle);
		}


		// update all the media elemenmts that are in the desktop grid.
		updateMediaGrid(newProductObject.product.images, newProductObject);

		// handle the UI and functionality of selecting a size variant
		variantSizeSelection(newProductObject.product.variants);

		// if mobile scroll top of view and update other data
		updateMobilePdpView();

		if (
			Alpine.store("activeProduct")?.activeProduct.product_option_titles.length >
			1
		) {
			selectedItemOne = null;
			selectedItemTwo = null;

			Alpine.store("selectedVariant").updateActiveVariant({
				id: "",
				title: "Select A Size",
				displayAtc: false,
			});
		}
	});

	// Args e = click event data from clicked size component
	document.addEventListener("selectedVariant", (e) => {

		// Do nothing if its already selected
		if (e.target.id === Alpine.store("selectedVariant").id) return;

		if (
			Alpine.store("activeProduct")?.activeProduct.product_option_titles.length >
			1
		) {

			const dataset = e.target.dataset;
			const selectedItem = dataset.item;
			const isActiveClass = `vselect_option--active-${dataset.parent}`;

			// Update selected item based on parent using Alpine store
			if (dataset.parent != "size") {
				Alpine.store("vMultiSelect").updateActiveOptionTwo(selectedItem);
			} else {
				Alpine.store("vMultiSelect").updateActiveOptionOne(selectedItem);
			}

			// Toggle active class
			let elm = document.querySelector(`.${isActiveClass}`);
			if (elm) {
				elm.classList.remove("vselect_option--active", isActiveClass);
			}
			e.target.classList.add("vselect_option--active", isActiveClass);

			// Update active variant if both options are selected
			const optionOne = Alpine.store("vMultiSelect").activeOptionOne;
			const optionTwo = Alpine.store("vMultiSelect").activeOptionTwo;

			if (optionOne !== undefined && optionTwo !== undefined) {
				const variant = Alpine.store(
					"activeProduct"
				).activeProduct.variants.find(
					(o) => `${o.option1}-${o.option2}` === `${optionOne}-${optionTwo}`
				);

				if (variant && variant.available) {
					Alpine.store("selectedVariant").updateActiveVariant({
						id: variant.id,
						title: `${Alpine.store("vMultiSelect").activeOptionOne} - ${Alpine.store("vMultiSelect").activeOptionTwo
							}`,
						displayAtc: true,
					});

					// Call the updateWishlistAndDispatchEvent function with the new variant
					updateWishlistAndDispatchEvent(
						Alpine.store("activeProduct").activeProduct.id,
						variant.id,
						Alpine.store("activeProduct").activeProduct.handle
					);
				} else {
					Alpine.store("selectedVariant").updateActiveVariant({
						id: "",
						title: "",
						displayAtc: false,
					});
				}
			}

			// Update available options based on selected item
			let data = Alpine.store("activeProduct").activeProduct.variants;
			let allOptions = data
				.filter(
					(o) => o.optionsArray.includes(e.target.dataset.item) && o.available
				)
				.flatMap((item) => item.optionsArray);
			if (e.target.dataset.parent != 'style') {
				document
					.querySelectorAll(".fusion-pdp__vselect-option-style")
					.forEach((elm) => {
						elm.disabled = !allOptions.includes(elm.dataset.item);
					});
			}

		} else {
			let elm = document.querySelector(".vselect_option--active");
			if (elm && typeof elm !== undefined) {
				elm.classList.remove("vselect_option--active");
				e.target.classList.add("vselect_option--active");
			} else {
				e.target.classList.add("vselect_option--active");
			}

			Alpine.store("selectedVariant").updateActiveVariant({
				id: e.target.id,
				title: e.target.innerText,
				displayAtc: true,
			});

			// Call the updateWishlistAndDispatchEvent function with the new variant
			updateWishlistAndDispatchEvent(
				Alpine.store("activeProduct").activeProduct.id,
				e.target.id,
				Alpine.store("activeProduct").activeProduct.handle
			);

		}




	});

	document.addEventListener("pdpAtc", (event) => {
		fusionAtcAdd(event);
	});
};
